import React from "react";
import {withStyles} from "@material-ui/core/styles";
import {createStyles} from "@material-ui/core";

const styles = () => createStyles({
    correctDiffAdd: {
        backgroundColor: 'rgb(234, 254, 210)',
        fontSize: 14,
        marginLeft: 5,
        height: 'fit-content',
        position: 'relative',
        top: 12,
        padding: 3
    },
    correctDiffRemove: {
        backgroundColor: 'rgb(254, 221, 222)',
        fontSize: 14,
        marginLeft: 5,
        height: 'fit-content',
        position: 'relative',
        top: 12,
        padding: 3
    },
    correctDiffAddHistory: {
        backgroundColor: 'rgb(234, 254, 210)',
        fontSize: 14,
        marginLeft: 5,
        padding: 3
    },
    correctDiffRemoveHistory: {
        backgroundColor: 'rgb(254, 221, 222)',
        fontSize: 14,
        marginLeft: 5,
        padding: 3
    }
})

/**
 * Комопнент для отображения изменений правильности ответа.
 */
const AnswerChanges = withStyles(styles)(({classes, answer, historyMode}: any) => {
    const classAdd = historyMode ? classes.correctDiffAddHistory : classes.correctDiffAdd
    const classRemove = historyMode ? classes.correctDiffRemoveHistory : classes.correctDiffRemove

    return (
        <>
            {answer.oldCorrect == 1 && (
                <div className={classAdd}>
                    {answer.oldCorrect == 1 && (
                        <span>установил(а) правильный ответ</span>
                    )}
                    &nbsp;
                    {answer.authorCorrectChange}
                </div>
            )}
            {answer.oldCorrect == 0 && (
                <div className={classRemove}>
                    {answer.oldCorrect == 0 && (
                        <span>убрал(а) правильный ответ</span>
                    )}
                    &nbsp;
                    {answer.authorCorrectChange}
                </div>
            )}
        </>
    )
});

export default AnswerChanges